require('./reportService');
require('./../../shared/dateService');

"use strict";

angular.module('app.admin.reports.reportsController', [
  'app.admin.reports.reportService',
  'app.shared.dateService'
])
  .controller('app.admin.reports.reportsController', [
    '$scope',
    'app.admin.reports.reportService',
    'app.shared.dateService',
    'PRODUCT',
    function ($scope, reportService, dateService, PRODUCT) {
      $scope.season = null;
      $scope.dataLoading = false;
      $scope.fileLoading = false;
      $scope.reportsMap = null;
      $scope.heatmap = null;
      $scope.prevSelection = null;
      $scope.type = null;

      $scope.report = reportService;
      $scope.seasonList = [];
      $scope.availableTypes = {
        league: null,
        team: null,
        event: null,
      };

      $scope.product = PRODUCT;

      let league_team = null;

      let init = function () {
        $scope.report.clear();

        switch (PRODUCT.Code) {
          case "ahl":
            $scope.seasonList = dateService.generateSeasonList(29, '2018/2019');
            break;
          case "htv":
          default:
            $scope.seasonList = dateService.generateSeasonList(25, '2014/2015');
            break;
        }

        if ($scope.seasonList.length === 1) {
          $scope.season = $scope.seasonList[0]
        }

        $scope.report.getSelections().then(() => {
          if ($scope.report.list) {
            if ($scope.report.list.leagues.length === 1) {
              $scope.selectedOption($scope.report.list.leagues[0]);
            } else if ($scope.report.list.teams.length === 1) {
              $scope.selectedOption($scope.report.list.teams[0]);
            }
          }
        });

        let mapOptions = {
          zoom: 4,
          center: new google.maps.LatLng(40.0000, -98.0000),
          mapTypeId: google.maps.MapTypeId.SATELLITE,
        };

        let mapElem = $(".report").find("#reportsMap")[0];

        $scope.reportsMap = new google.maps.Map(mapElem, mapOptions);
      };

      $scope.selectedOption = function (type) {
        if ($scope.season && type) {

          $scope.dataLoading = true;
          $scope.type = type;

          if ($scope.heatmap) {
            $scope.heatmap.setMap(null);
            $scope.heatmap = null;
          }

          reportService.clear();

          let selection = $scope.typeSelected(type);
          selection.season_id = $scope.season.id;
          $scope.prevSelection = $scope.season.id;

          reportService.retrieve(selection);
        }
      };

      $scope.getReportFile = function (fileType) {
        $scope.fileLoading = true;
        let selection = $scope.typeSelected($scope.type);
        selection.season_id = $scope.season.id;

        let filename = "";
        if ($scope.type.ileagueid) {
          filename = $scope.type.strleaguename.replace(" ", "_") + "_" + $scope.season.year.replace("/", "-")
        } else if ($scope.type.iteamid) {
          filename = $scope.type.strteamname + "_" + $scope.type.strteammascot + "_" + $scope.season.year.replace("/", "-")
        } else {
          filename = "event";
        }

        let fileParams = {
          type: fileType,
          filename: filename,
        };

        reportService.getReportFile(fileParams, selection);
      }

      $scope.assignReportSelection = function (aggregate) {
        if (aggregate.iteamid !== undefined) {
          league_team = aggregate;
          $scope.selectedOption(aggregate);
        }
      };

      $scope.typeSelected = function (type) {
        let selection = null;

        switch (true) {
          case type.ileagueid !== undefined:
            selection = {
              type: 'league',
              select_id: type.ileagueid
            };
            break;
          case type.iteamid !== undefined:
            selection = {
              type: 'team',
              select_id: type.iteamid
            };
            break;
          case type.calid !== undefined:
            selection = {
              type: 'event',
              select_id: type.calid
            };
            break;
          default:
            return null;
        }

        $scope.selection = selection;

        clearTypes(selection.type);
        return selection;
      };

      let clearTypes = (type) => {
        if (type === 'all') {
          _.each($scope.availableTypes, (type) => {
            type = null;
          });
        } else {
          _.each(Object.getOwnPropertyNames($scope.availableTypes), (property) => {
            if (property !== type) {
              $scope.availableTypes[property] = null
            }
          });
        }

      };

      $scope.isTypesEmpty = () => {
        return (!$scope.availableTypes.team && !$scope.availableTypes.league && !$scope.availableTypes.event
          && !league_team);
      };

      $scope.seasonUpdated = () => {
        if ($scope.season && PRODUCT.Code === 'htv') {
          if ($scope.season.id !== $scope.prevSelection) {

            let selectedType = null;

            _.each($scope.availableTypes, (type) => {
              if (angular.isObject(type)) {
                selectedType = type;
              }
            });

            if (selectedType && selectedType.hasOwnProperty('calid')) {
              clearTypes('all');
            } else if (selectedType && !selectedType.hasOwnProperty('calid')) {
              if (league_team) {
                league_team = null;
              }

              $scope.selectedOption(selectedType);
            }

            $scope.report.clear();

            if ($scope.heatmap) {
              $scope.heatmap.setMap(null);
              $scope.heatmap = null;
            }
          }
          reportService.getEvents($scope.season.id);
        }
      };

      $scope.prepHeatMap = function (map) {
        if ($scope.report.points) {
          $scope.heatmap = new google.maps.visualization.HeatmapLayer({
            data: $scope.report.points,
            map: map
          });
        }
      };

      $scope.$watch('report.viewerships', function () {
        if ($scope.report.viewerships) {
          $scope.dataLoading = false;
        }
        $scope.prepHeatMap($scope.reportsMap);
      });

      $scope.$watch('report.loading', function () {
        if (!$scope.report.loading) {
          $scope.fileLoading = false;
        }
      });

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/reports/reportsController.js